import { ICitationPublishingRule } from '@vivli/features/data-requests/infrastructure/interface';
import { CSSProperties } from 'react';
import { useCitationsContext } from '@vivli/shared/features/citations/infrastructure/context';
import { PublishedCitationComponent } from '@vivli/shared/features/citations/components';
import { Size } from '@vivli/shared/theme';

const sectionStyle: CSSProperties = {
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingLeft: 0,
    paddingRight: 0,
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: Size.INSET_SIZE,
    paddingTop: 0,
};

interface DisclosuresRowPreviewComponentProps {
    citationToShow: ICitationPublishingRule;
    index?: number;
    isConfigMode: false;
}

export const DisclosuresRowPreviewComponent = ({ citationToShow, index, isConfigMode }: DisclosuresRowPreviewComponentProps) => {
    const { citations } = useCitationsContext();
    const citationId = citationToShow.citationReferenceId;
    const thisCitationDetail = citations?.find((c) => c.id === citationId);

    return (
        <>
            {thisCitationDetail !== undefined &&
                citationToShow.publishable &&
                citationToShow.citationReferenceId === thisCitationDetail.id && (
                    <div style={sectionStyle}>
                        <div>
                            <PublishedCitationComponent citation={thisCitationDetail} />
                        </div>
                    </div>
                )}
        </>
    );
};
